import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import ReactMapGL, { WebMercatorViewport } from 'react-map-gl'
import cx from 'classnames'
import { bbox, lineString } from '@turf/turf'

import Progress from '../../Progress/Progress'
import { useOOGlobals } from '../../OOGlobalsProvider/OOGlobalsProvider'
import { Pins } from './Pins/Pins'

import './Map.css'

export const Map = ({ loading, restaurants }) => {
  const { mapboxAccessToken } = useOOGlobals()
  const [viewport, setViewport] = useState({})
  const [initialized, setInitialized] = useState(false)

  const setZoom = useCallback(
    ({ width, height }) => {
      if (!width || !height) return
      const vp = new WebMercatorViewport({ ...viewport, height, width })
      const bounds = lineString(
        restaurants.reduce(
          (acc, { location }) => [
            ...acc,
            [location.longitude, location.latitude]
          ],
          []
        )
      )
      const [minLng, minLat, maxLng, maxLat] = bbox(bounds)
      const { longitude, latitude, zoom } = vp.fitBounds(
        [[minLng, minLat], [maxLng, maxLat]],
        { padding: 40 }
      )
      setViewport({ ...viewport, longitude, latitude, zoom })
    },
    [restaurants, viewport]
  )

  const initialize = useCallback(() => {
    setInitialized(true)
    setZoom(viewport)
  }, [setZoom, viewport])

  const onResize = useCallback(({ width, height }) => {
    if (!initialized) return
    setZoom({ width, height })
  }, [initialized, setZoom])

  if (loading) return <Progress eventData={{ category: 'Multi Location Map' }} />

  return (
    <div styleName={cx('wrapper', { initialized })}>
      <ReactMapGL
        {...viewport}
        onViewportChange={vp => setViewport(vp)}
        mapStyle='mapbox://styles/mapbox/streets-v11?optimize=true'
        width='100%'
        height='100%'
        mapboxApiAccessToken={mapboxAccessToken}
        onLoad={initialize}
        onResize={onResize}
      >
        <Pins data={restaurants} onClick={rest => console.log(rest)} />
      </ReactMapGL>
    </div>
  )
}

Map.propTypes = {
  loading: PropTypes.bool,
  restaurants: PropTypes.array
}
